import { Command } from 'ckeditor5';
import { extractAttachmentIdFromHref } from '../../util/HTMLElementUtils';

export class QualioAttachmentPreviewCommand extends Command {
  static readonly commandName = 'QualioAttachmentPreviewCommand';
  override get affectsData(): boolean {
    return false;
  }

  private _getLinkHref(): string | undefined {
    const selection = this.editor.model.document.selection;
    const href =
      selection.getAttribute('linkHref') ??
      selection.getSelectedElement()?.getAttribute('src');

    if (!href || typeof href !== 'string') return undefined;
    return href;
  }

  refresh(): void {
    const href = this._getLinkHref();
    this.isEnabled = href ? !!extractAttachmentIdFromHref(href) : false;
  }

  execute(): void {
    const onOpen = this.editor.config.get('attachmentPreview.onOpen') as (
      id: string,
    ) => void;
    const href = this._getLinkHref();
    if (!href) return;

    const attachmentId = extractAttachmentIdFromHref(href);

    if (attachmentId && onOpen) {
      (this.editor.plugins.get('LinkUI') as any)._hideUI();
      onOpen(attachmentId);
    }
  }
}
